import { AnalyticsBrowser } from '@segment/analytics-next'
import { JWTPayload, UserV1 } from '@tovala/browser-apis-combinedapi'
import { mapValues } from 'lodash-es'
import * as Sentry from '@sentry/react'

import { AnalyticsEvent } from 'analytics/events'
import { getEnvVar } from './env'

const CODE_VERSION = getEnvVar('VERCEL_GIT_COMMIT_SHA')

const analytics = new AnalyticsBrowser()

if (getEnvVar('APP_ENV') !== 'test') {
  analytics.load({
    writeKey: getEnvVar('SEGMENT_WRITE_KEY'),
  })
}

export function coerceValuesToStrings(
  obj: Record<string, number | string | null | undefined>,
) {
  return mapValues(obj, (value) => {
    if (typeof value === 'number') {
      return `${value}`
    } else if (value === undefined || value === null) {
      return ''
    }

    return value
  })
}

export function identifyUser({ user }: { user: UserV1 }): void {
  analytics.identify(`${user.id}`, {
    email: user.info.email,
    name: user.info.name,
    system: 'mytovala',
    version: CODE_VERSION,
  })

  Sentry.setUser({
    id: `${user.id}`,
    version: CODE_VERSION,
  })
}

export function identifyUserFromJWT({
  decodedJWT,
}: {
  decodedJWT: JWTPayload
}): void {
  analytics.identify(`${decodedJWT.userId}`, {
    system: 'mytovala',
    version: CODE_VERSION,
  })

  Sentry.setUser({
    id: `${decodedJWT.userId}`,
    version: CODE_VERSION,
  })
}

export function identifyRetailChannel({
  userID,
  retailChannel,
  location,
  phoneNumber = '',
}: {
  userID: number
  retailChannel: string
  location: string
  phoneNumber?: string
}): void {
  analytics.identify(`${userID}`, {
    retailChannel,
    retailLocation: location,
    retailPhone: phoneNumber,
  })
}

export function page() {
  analytics.page()
}

export function track(
  eventName: AnalyticsEvent,
  eventProps?: Record<string, number | string | null | undefined>,
) {
  analytics.track(
    eventName,
    // Note: we want to ensure our attributes are sent as strings to make analysis
    // easier / more consistent. See https://tovala.atlassian.net/browse/WAT-672.
    eventProps ? coerceValuesToStrings(eventProps) : undefined,
  )
}
